<template>
  <v-card>
    <v-card-title>
      <v-select
        v-model="selectedParkingArea"
        :items="parkingAreas"
        label="Parking Area"
        item-text="parkingName"
        item-value="parkingAreaID"
      />
      <v-spacer/>
      <IconButton
        tooltip="Print"
        color="indigo"
        icon="fa-print"
        @click="print()"
      />
      <v-spacer/>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      />
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="items"
      :search="search"
      hide-actions
      class="elevation-1"
    >
      <template
        slot="items"
        slot-scope="props"
      >
        <td>{{ props.item.parkingName }}</td>
        <td>{{ props.item.person }}</td>
        <td>{{ props.item.vehicle }}</td>
        <td> {{ props.item.gatePasses }} </td>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
// import vuex mapping
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      search: '',
      selectedParkingArea: false,
      headers: [
        {
          text: 'Parking Area',
          value: 'parkingName',
          sortable: false
        },
        {
          text: 'Person',
          value: 'person',
          sortable: false
        },
        {
          text: 'Vehicle',
          value: 'vehicle',
          sortable: false
        },
        {
          text: 'Gate Pass',
          value: 'gatePasses',
          sortable: false
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      gateParkingReport: 'reports/gateParkingReport',
      parkingAreas: 'facilities/parkingAreas'
    }),
    formattedRows () {
      let formattedBookings = this.gateParkingReport.map((row) => {
        row.person = `${row.lastName}, ${row.firstName} (${row.personID})`
        row.vehicle = `${row.vehicleMake} ${row.vehicleModel} (${row.vehicleState} ${row.vehicleLicensePlate})`
        return row
      })
      return this.parkingAreas.reduce((reportArray, parkingArea) => {
        let bookingsForArea = formattedBookings.filter(row => row.parkingAreaID === parkingArea.parkingAreaID)
        reportArray.push(...bookingsForArea)
        console.log(`capacity ${parkingArea.parkingCapacity}`)
        console.log(`bookings ${bookingsForArea.length}`)
        for (let i = 0; i < parkingArea.parkingCapacity - bookingsForArea.length; i++) {
          reportArray.push(parkingArea)
        }
        return reportArray
      }, [])
    },
    items () {
      return this.formattedRows.filter(row => row.parkingAreaID === this.selectedParkingArea)
    }
  },
  methods: {
    print () {
      window.print()
    }
  }
}
</script>
